module.exports = __webpack_public_path__ + "img/N351-1.8802a286.png";